module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui error message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Fehler")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6a69ca68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/error-indicator.vue
// module id = 360
// module chunks = 0